var _path, _polygon, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.44mm",
    height: "6.56mm",
    viewBox: "0 0 15.43 18.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.34,0h-7.26v1.5h7.26c1.43,0,2.59,1.16,2.59,2.59v10.4c0,1.43-1.16,2.59-2.59,2.59h-7.26v1.5h7.26c2.26,0,4.09-1.84,4.09-4.09V4.09c0-2.26-1.84-4.09-4.09-4.09Z",
    fill: "currentColor"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.06 13.01 10.82 9.25 7.14 5.57 6.07 6.63 8.7 9.25 6 11.95 7.06 13.01",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8.54,
    width: 6.57,
    height: 1.5,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIco);
export default __webpack_public_path__ + "static/media/login-ico.39016ff4d2740b7e98e51e0bc4f92b24.svg";
export { ForwardRef as ReactComponent };